import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { ShieldCheck } from "lucide-react";
import { API, formatRupiah, timeAgo } from "@/lib/site";
import { Reveal } from "./motion-prims";

export default function DonorWall() {
  const { data: donations } = useQuery({
    queryKey: ["donations"],
    queryFn: async () => (await axios.get(`${API}/donations`)).data,
  });

  return (
    <section id="transparansi" className="scroll-mt-20 bg-paper border-y-2 border-ink/10 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-gold-dark">Transparansi</p>
          <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
            <h2 className="font-display font-black tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
              Dinding Donatur
            </h2>
            <p className="flex items-center gap-2 max-w-sm text-sm sm:text-base text-pine leading-relaxed">
              <ShieldCheck className="w-5 h-5 text-olive shrink-0" />
              Setiap konfirmasi dicatat dan dilaporkan. Kontak donatur selalu disamarkan.
            </p>
          </div>
        </Reveal>

        <div data-testid="donors-wall" className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {(donations || []).map((d, i) => (
            <Reveal key={d.id} delay={Math.min(i * 0.05, 0.3)} className="h-full">
              <article
                data-testid={`donor-card-${i}`}
                className="h-full bg-cream border-2 border-ink rounded-2xl p-5 shadow-retro-sm flex flex-col gap-3 transition-transform hover:-translate-y-1"
              >
                <div className="flex items-center gap-3">
                  <span className="grid place-items-center w-10 h-10 rounded-full bg-olive text-gold-soft font-display font-black">
                    {d.name.charAt(0).toUpperCase()}
                  </span>
                  <div className="min-w-0">
                    <p className="font-bold text-sm truncate">{d.name}</p>
                    <p className="text-[11px] text-pine">{timeAgo(d.created_at)}</p>
                  </div>
                </div>
                <p className="font-display font-black text-lg text-gold-dark">{formatRupiah(d.amount)}</p>
                {d.message && <p className="text-sm leading-relaxed text-pine flex-1">“{d.message}”</p>}
                <span className="text-[10px] font-bold uppercase tracking-[0.12em] bg-paper border border-ink/20 rounded-full px-3 py-1.5 w-fit">
                  {d.campaign_title}
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
